<template>
    <div class="projectOperate">
        <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item name="1">
                <template slot="title">
                    <h4>项目信息</h4>
                </template>
                <ul v-if="iszc" class="proInfoBtn">
                    <li>
                        <el-button type="text" 
                            @click="operateClick('项目详情')">
                                招标项目详情
                        </el-button>
                    </li>
                    <li>
                        <el-button type="text" 
                            @click="dialogShow('formelecShow','3','委托合同')">
                                委托合同
                        </el-button>
                    </li>
                    <li v-if="(procodeInfo.shbj==='1'||procodeInfo.shbj==='9')&&(procodeInfo.jyzxcode!==null&&procodeInfo.jyzxcode.indexOf('J1304')>-1)">
                        <el-button type="text" 
                            @click="dialogShow('formelecShow','1','电子协议')">
                                签署承诺书
                        </el-button>
                    </li>
                    <li>
                        <el-button type="text" 
                            @click="dialogShow('formelecShow','1','电子协议')">
                                电子协议
                        </el-button>
                        <el-tooltip v-if="liuchengShow==1" class="item" effect="light" content="此项目需要填写该内容" placement="right-start">
                            <i class="el-icon-warning" style="color:#e6a23c"></i>
                        </el-tooltip>
                    </li>
                </ul>
                <ul v-if="!iszc" class="proInfoBtn">
                    <li>
                        <el-button type="text" 
                            @click="operateClick('项目详情')">
                                项目详情
                        </el-button>
                    </li>
                    <li>
                        <el-button type="text" 
                            @click="operateClick('招标项目详情')">
                                招标项目详情
                        </el-button>
                    </li>
                    <li>
                        <el-button type="text" 
                            @click="dialogShow('commonformShow','xmzl','设置项目助理')">
                                设置项目助理
                        </el-button>
                    </li>
                    <li>
                        <el-button type="text" 
                            @click="dialogShow('commonformShow','xmdm','补充统一项目代码')">
                                补充统一项目代码
                        </el-button>
                    </li>
                    <li>
                        <el-button type="text" 
                            @click="jspClick('/Zbdl/ZbProject/Zbdlwtht/zbdlwthtdata.do?procode=','补充委托合同数据')">
                                委托合同
                        </el-button>
                    </li>
                    <li v-if="procodeInfo.by3==='102'">
                        <el-button type="text" 
                            
                            @click="downzsxsm">
                                下载真实性声明
                        </el-button>
                    </li>
                    <li v-if="(procodeInfo.shbj==='1'||procodeInfo.shbj==='9')&&procodeInfo.ext5.indexOf('1304')>-1">
                        <el-button type="text" 
                            @click="jspClick('/Zbdl/ZbProject/Zbdlcns/index?zbprocode=','签署承诺书')">
                                签署承诺书
                        </el-button>
                    </li>
                    <li>
                        <el-button type="text" 
                            @click="dialogShow('formelecShow','1','电子协议')">
                                电子协议
                        </el-button>
                         <el-tooltip v-if="liuchengShow==1" class="item" effect="light" content="此项目需要填写该内容" placement="right-start">
                            <i class="el-icon-warning" style="color:#e6a23c"></i>
                        </el-tooltip>
                    </li>
                </ul>

            </el-collapse-item>
        </el-collapse>
   
        <my-dialog
        v-model="dialogVisible"
        :title="dialogTitle"
        width="80%"
        @close="dialogClose">
            <!--设置项目助理 统一项目代码弹窗-->
            <common-form
                v-if="commonformShow"
                :row="row"
                :type="jsgctype"
                @reloadpage="$emit('reload')"
                @cancle="dialogClose">
            
            </common-form>

            <!--签署承诺书 电子协议 政府采购委托合同弹窗-->
            <form-elec-agree
                v-if="formelecShow"
                :type="type"
                :row="row"
                @cancle="dialogClose">
            </form-elec-agree>
        </my-dialog>

        <!--弹窗调用jsp页面-->
        <el-dialog
            :title="jspTitle"
            class="jspdialog"
            :visible.sync="jspdialogVisible">
                <iframe 
                    style="width:100%;height:100%"
                    class="frame-item"
                    :src="jspSrc" 
                    frameborder="0"
                ></iframe>
            
        </el-dialog>

    </div>
</template>

<script>
import CommonForm from '@views/bidding/views/project/common/form'
import FormElecAgree from '@views/bidding/elec-agreement/form'
export default {
    components: {CommonForm,FormElecAgree},
    props: {
        iszc: {
            type: Boolean,
            default: false,
        },
        procodeInfo:{
            type: Object,
            default: () => ({}),
        }
    },
    data() {
        return {
            operateList:[],
            // 弹窗组件需要参数
            row:{},
            dialogVisible:false,
            type:'',
            jsgctype:'',
            dialogTitle:'',
            commonformShow:false,
            formelecShow:false,
            // 调用jsp弹窗
            jspdialogVisible:false,
            jspSrc:'',
            jspTitle:'',

            activeNames:['1'],
            liuchengShow:'',
        }
    },
    watch: {
        
    },
    methods: {
        // 跳转详情页
        operateClick(name){
            if(name=='项目详情'){
                if(this.iszc){
                    this.$emit('goFrame','/#/bidding/project/zfcg/detail?id='+this.procodeInfo.zbprocode+'&type='+this.procodeInfo.ext3+'&childtype='+'')
                }else{
                    this.$emit('goFrame','/#/bidding/project/detail?id='+this.procodeInfo.procode)
                }
            }else if(name=='招标项目详情'){
                this.$emit('goFrame','/#/iframe?title=招标项目流程&url=/Zbdl/ZbProject/detail?id='+this.procodeInfo.zbprocode)
            }
            
        },
        //项目助理 补充统一项目代码弹窗
        dialogShow(type,val,title){
            this.row = this.procodeInfo;
            this.dialogVisible = true;
            if(type=='commonformShow'){
                this.dialogTitle = title;
                this.jsgctype = val;
                this.commonformShow = true;
            }else if(type=='formelecShow'){
                this.dialogTitle = title;
                this.type = val;
                this.formelecShow = true;
            }
        },
        // jsp弹窗
        jspClick(url,title,type){
            this.jspdialogVisible = true;
            this.jspSrc = url+this.procodeInfo.zbprocode+"&t="+ Math.random();
            this.jspTitle = title;
        },
        // 关闭弹窗
        dialogClose(){
            this.dialogVisible = false;
            if(this.commonformShow){
                this.commonformShow = false
            }else if(this.formelecShow){
                this.formelecShow = false
            }
        },
        // 下载真实性声明
        downzsxsm(){
            window.location.href = "/Zbdl/ZbProject/downzsxsm.do?zbprocode="+this.procodeInfo.zbprocode
        },
        // 折叠面板点击
        handleChange(){
            this.$emit('change',this.activeNames.length)
        },
        procodeInfoInt(){
            this.liuchengShow=1;
        }
        
    },
    created() {
        
    },
    mounted:function(){
        
    }
}
</script>


<style>
    .el-collapse{ border-top: none; }
    .projectOperate{ overflow: hidden;}
    .projectOperate li{ width: 115px; float: left; margin-right: 10px; margin-bottom: 10px; }
    .projectOperate li .el-button--text{ padding: 0}
    .jspdialog .el-dialog__body{ height: 800px;}
    .proInfoBtn{ overflow: hidden; }
    .proInfoBtn li .el-button--text{ color: #333; }
    .proInfoBtn li .el-button--text:hover{ color: #409EFF; }
    .el-collapse-item__content{ padding-bottom: 0; }
   
</style>